import React from 'react';

import './MetaChip.scss';

// Label/value chip: quiet enough to stay behind the titles and actions it sits
// beside, but readable at a glance. Shared by the organization header and cards
// so both read the same way.
const MetaChip = ({ icon, label, id, children, className = '' }) => (
    <span className={`meta-chip ${className}`.trim()} id={id}>
        <span className={`fas fa-fw ${icon}`}/>
        <span className="meta-label">{label}</span>
        {children}
    </span>
);

export default MetaChip;
